import { Injector } from "@angular/core";
import { WorkspaceBase } from "../../workspace-base/workspace-base";
import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Checks/unchecks all checkboxes
 */
export class UnselectCheckboxesGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'UnselectSelectAllCb');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    this.workspace.grid.selectOrDeselectAllCheckbox();
  }
}
